import { FETCH_ZONE, RESET_ZONE } from "../../constants/action.constants";

const initialState = {
  data: {},
};

const zoneViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ZONE:
      return { data: action.payload };
    case RESET_ZONE:
      return initialState;
    default:
      return state;
  }
};

export default zoneViewReducer;
